import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class TwoFactorAuthenticationMethod extends Mappable {
  id!: string
  title!: string

  static create<Data>(attrs: Data) {
    return new TwoFactorAuthenticationMethod().map(attrs)
  }
}
